import { persistentStore, sessionStore, buildKey } from './stores'
import { clearRequestCache, invalidateRequest, invalidateRequestsByPrefix } from './requestCache'
import { STORAGE_KEYS } from './keys'

function clearPersistentAuth() {
  persistentStore.remove(STORAGE_KEYS.OPERATOR)
  persistentStore.remove(STORAGE_KEYS.TOKEN)
  persistentStore.remove(STORAGE_KEYS.SA_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.OPERATOR_RAW)
  localStorage.removeItem(STORAGE_KEYS.SLUG)
  localStorage.removeItem(STORAGE_KEYS.PORTAL_ACCESS)
}

function clearPersistentAppState() {
  persistentStore.remove(STORAGE_KEYS.SUBSCRIPTION_PLAN)
  persistentStore.remove(STORAGE_KEYS.WARNINGS)
  localStorage.removeItem(STORAGE_KEYS.PANEL_HISTORY)
  localStorage.removeItem(STORAGE_KEYS.SELECTED_CODES)
}

function clearAllPersistentCache() {
  clearPersistentAuth()
  clearPersistentAppState()
}

function clearAllCache() {
  clearRequestCache()
  clearAllPersistentCache()
}

function invalidate(target) {
  invalidateRequest(target)
  invalidateRequestsByPrefix(target)
}

function removeLegacyKey(key) {
  localStorage.removeItem(key)
  localStorage.removeItem(buildKey(key))
}

export const cacheManager = {
  invalidate,
  invalidateByPrefix: invalidateRequestsByPrefix,
  clearRequestCache,
  clearPersistentAuth,
  clearPersistentAppState,
  clearAllPersistentCache,
  clearAllCache,
  removeLegacyKey,
}
